/** Named waypoint colors — single source of truth for all color references */
export const WAYPOINT_COLORS = {
  RED: "#E50505",
  ORANGE: "#FF731E",
  YELLOW: "#FFCC4C",
  GREEN: "#12B058",
  BLUE: "#1F65F0",
  PURPLE: "#8B26FF",
} as const;

/**
 * Waypoint color palette for color picker in settings.
 * Automatically derived from WAYPOINT_COLORS — changes to colors are reflected here.
 */
export const WAYPOINT_COLOR_PALETTE = Object.values(WAYPOINT_COLORS);

/**
 * Default waypoint color used when no custom color has been set.
 * Always references WAYPOINT_COLORS.BLUE — guaranteed to be in sync with the palette.
 */
export const DEFAULT_WAYPOINT_COLOR = WAYPOINT_COLORS.BLUE;
